<template>
    <div class="modal opacity-0 w-full h-full absolute pointer-events-none top-0 left-0 flex items-center justify-center" role="dialog" id="preliminary-cancellation-info-modal">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Preliminär avbokning</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <input type="hidden" id="cancel-booking-modal-id">
                </div>

                <div class="modal-body">
                    <div class="h6 font-weight-bold"><span id="cancel-booking-modal-time"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-location"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-treatment"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-therapist"></span></div>
                    <div class="preliminary-warning" id="cancel-booking-modal-prelim-warning">
                        <div>Om en behandling avbokas efter att gränsen för avbokning passerat så sker en <strong>preliminär avbokning</strong>.
                        </div>
                        <div>Detta innebär att tillgodohavandet som användes för att boka behandlingen förbrukas
                        ifall annan användare ej bokar en behandling under den schemalagda tiden.</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> Stäng</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomerDashModalPrelimCancellationInfo"
    }
</script>

<style scoped>

</style>